









































































import { Component } from 'vue-property-decorator';
import { GeneralLedgerAccountsModule } from '@/store/Accounting/GeneralLedgerAccountsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import CreateGeneralLedgerAccountRequest from '@/models/Accounting/GeneralLedgerAccounts/CreateGeneralLedgerAccountRequest';
import PageNames from '@/router/PageNames';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'GeneralLedgerAccountCreate', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    request: CreateGeneralLedgerAccountRequest = new CreateGeneralLedgerAccountRequest();
    accountCode: string = '';

    get availableCurrencies() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

    get accountTypeOptions() {
        return ListUtils.generalLedgerAccountTypeOptions();
    }

    get loadingNewGeneralLedgerAccount() {
        return GeneralLedgerAccountsModule.loadingNewGeneralLedgerAccount;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Convert the account code into a number in the request
            this.request.code = +this.accountCode;

            await GeneralLedgerAccountsModule.createGeneralLedgerAccount(this.request);

            if (GeneralLedgerAccountsModule.newGeneralLedgerAccountID !== null) {
                this.$router.push({ name: PageNames.GeneralLedgerAccount, params: { id: GeneralLedgerAccountsModule.newGeneralLedgerAccountID }, query: { tab: "0" } });
            }
        }
    }

    cancel() {
        this.dialog = false;
    }

}
